<template>
  <!-- 新增一个根元素 div 包裹所有内容 -->
  <div class="header-wrapper">
    <el-header>
      <div class="header-container">
        <!-- 左侧：电话信息 -->
        <div class="header-item">
          <el-image :src="phoneImgUrl" class="icon-img" />
          <span class="text">0046-070428 17 56</span>
        </div>

        <!-- 中间：Logo -->
        <div class="header-item">
          <el-image :src="logoImgUrl" class="logo-img" />
          <span class="text">Y&G Health AB</span>
        </div>

        <!-- 右侧：菜单 -->
        <div class="menu-container">
          <!-- 小屏幕下显示菜单按钮 -->
          <el-button
            v-if="isSmallScreen"
            @click="isMenuVisible = true"
            icon="el-icon-menu"
            class="menu-button"
          ></el-button>
          <!-- 大屏幕下的菜单 -->
          <el-menu
            v-if="!isSmallScreen"
            :default-active="activeIndex"
            mode="horizontal"
          >
            <el-menu-item index="1"><router-link to="/">HEM</router-link></el-menu-item>
            <el-menu-item index="2"><router-link to="/experience">VÅR ERFARENHET</router-link></el-menu-item>
            <el-menu-item index="3"><router-link to="/help">HJÄLP</router-link></el-menu-item>
            <el-submenu index="4">
              <template #title><router-link to="">BEHANDLINGAR</router-link></template>
              <el-menu-item index="4-1"><router-link to="/terapi">INDIVIDUELL TERAPI</router-link></el-menu-item>
              <el-menu-item index="4-2"><router-link to="/prise">PRISER</router-link></el-menu-item>
            </el-submenu>
            <el-submenu index="5" :popper-append-to-body="true">
              <template #title><router-link to="/peosonInfo">OM OSS</router-link></template>
              <!-- OM OSS</template> -->
              <el-menu-item index="5-1">
                <router-link to="/akupunkturIKina">AKUPUNKTUR I KINA</router-link>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="6">
              <template #title>More</template>
              <el-menu-item index="6-1"><router-link to="/kontakt">KONTAKT</router-link></el-menu-item>
              <el-submenu index="6-2">
                <template #title>HÄLSA</template>
                <el-menu-item index="6-2-1"><router-link to="/dags">Dags</router-link></el-menu-item>
              </el-submenu>
              <el-menu-item index="6-3"><router-link to="/nyheter">NYHETER</router-link></el-menu-item>
              <el-menu-item index="6-4">
                <router-link to="/infertilitet" class="full-width-link">Infertilitet</router-link>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
    </el-header>
    <!-- 小屏幕下的侧边栏菜单 -->
    <el-drawer
      title="Meny"
      :visible.sync="isMenuVisible"
      direction="ltr"
      size="70%"
      :modal="false"
      :modal-class="'custom-drawer-modal'"
      v-if="isSmallScreen"
    >
      <el-menu
        :default-active="activeIndex"
        mode="vertical"
        class="vertical-menu custom-menu"
        text-color="#000"
        active-text-color="#2e7d32"
      >
        <el-menu-item index="1">
          <router-link to="/" class="full-width-link">HEM</router-link>
        </el-menu-item>
        <el-menu-item index="2">
          <router-link to="/experience" class="full-width-link">VÅR ERFARENHET</router-link>
        </el-menu-item>
        <el-menu-item index="3">
          <router-link to="/help" class="full-width-link">HJÄLP</router-link>
        </el-menu-item>
        <el-menu-item index="4-1">
          <router-link to="/terapi" class="full-width-link">INDIVIDUELL TERAPI</router-link>
        </el-menu-item>
        <el-menu-item index="4-2">
          <router-link to="/prise" class="full-width-link">PRISER</router-link>
        </el-menu-item>
        <el-menu-item index="5-1">
          <router-link to="/akupunkturIKina" class="full-width-link">AKUPUNKTUR I KINA</router-link>
        </el-menu-item>
        <el-menu-item index="6-1">
          <router-link to="/kontakt" class="full-width-link">KONTAKT</router-link>
        </el-menu-item>
        <el-menu-item index="6-2-1">
          <router-link to="/dags" class="full-width-link">Dags</router-link>
        </el-menu-item>
        <el-menu-item index="6-2">
          <router-link to="/dags" class="full-width-link">HÄLSA</router-link>
        </el-menu-item>
        <el-menu-item index="6-3">
          <router-link to="/nyheter" class="full-width-link">NYHETER</router-link>
        </el-menu-item>
        <el-menu-item index="6-4">
          <router-link to="/infertilitet" class="full-width-link">Infertilitet</router-link>
        </el-menu-item>
    </el-menu>
  </el-drawer>
</div>
</template>

<script>
export default {
  name: "HeaderP",
  data() {
    return {
      phoneImgUrl: require("@/assets/header/header-phone.png"),
      logoImgUrl: require("@/assets/header/logo.png"),
      isSmallScreen: window.innerWidth < 768,
      isMenuVisible: false,
      activeIndex: '1'
    };
  },
  methods: {
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
      this.isSmallScreen = this.screenWidth < 768;
    },
  },
  mounted() {
    window.addEventListener("resize", this.updateScreenWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenWidth);
  },
};
</script>

<style scoped>
.header-wrapper {
  width: 100%;
  /* position: fixed; */
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.el-header {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  height: auto;
  min-height: 60px;
}

.header-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap; /* 防止内容换行 */
  overflow: hidden; /* 隐藏溢出内容 */
}

.header-item {
  display: flex;
  align-items: center;
  margin: 0 10px;
  flex-shrink: 0;
  min-width: max-content; /* 防止内容被压缩 */
}

.menu-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-grow: 1;
  min-width: max-content; /* 防止内容被压缩 */
}

/* 头部每个部分 */
.header-item {
  display: flex;
  align-items: center;
  margin: 5px 0; /* 增加上下margin */
}

/* 右侧菜单 */
.menu-container {
  display: flex;
  align-items: center;
  order: 3; /* 将菜单放到最下面 */
  width: 100%; /* 占据整行 */
  justify-content: center; /* 居中 */
}

/* 图片样式 */
.icon-img {
  width: 18px; /* 稍微缩小 */
  height: 18px;
  margin-right: 5px;
}

.logo-img {
  width: 25px; /* 稍微缩小 */
  height: 25px;
  margin-right: 5px;
}

/* 文字样式 */
.text {
  font-size: 12px; /* 缩小字体 */
  white-space: nowrap;
}

/* 小屏幕菜单按钮 */
.menu-button {
  /* font-size: 14px; */
  /* padding: 12px; 调整按钮大小 */
}

/* 垂直菜单样式 */
.vertical-menu {
  width: 100%;
}

/* 响应式调整 */
@media (max-width: 480px) {
  .header-container {
    align-items: center;
  }
  
  .header-item {
    margin: 3px 0;
  }
  
  .text {
    font-size: 11px;
  }
}

@media (max-width: 768px) {
  .el-header {
    /* padding: 20px 10px; */
  }
  
  .header-container {
    padding: 0 5px; 
  }
  
  .header-item {
    margin: 0 5px; 
  }
  
  .text {
    font-size: 14px; 
  }
  
  .icon-img, .logo-img {
    width: 16px; 
    height: 16px;
  }
}

/* 新增样式 */
.full-width-link {
  display: block;
  width: 100%;
  height: 100%;
  color: inherit;
  text-decoration: none;
}

/* 修改原有样式 */
.el-menu-item > a {
  padding: 0 20px;
  display: block;
  width: 100%;
  height: 100%;
  color: inherit; /* 继承父元素颜色 */
  text-decoration: none; /* 去掉下划线 */
}
</style>

<style scoped>
/* 新增样式 */
.el-menu--horizontal {
  border-bottom: none !important;
}

.el-menu--horizontal .el-menu-item {
  border-bottom: 2px solid transparent;
  transition: border-color 0.3s;
}

.el-menu--horizontal .el-menu-item.is-active {
  border-bottom-color: #2e7d32; /* 使用与active-text-color相同的颜色 */
}

.custom-drawer-modal {
  pointer-events: none; /* 允许点击蒙版下的元素 */
}
</style>